"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _Combobox = _interopRequireDefault(require("../../Combobox/Combobox"));

var _Flag = _interopRequireDefault(require("../../../Layout/Flag/Flag"));

var _Label = _interopRequireDefault(require("../../Label/Label"));

var _theming = require("../../../../theming");

var _themeContants = require("../../../../constants/themeContants");

var _Input = _interopRequireDefault(require("../Input"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var defaultMapItem = function defaultMapItem(item) {
  if (!item) {
    return null;
  }

  return {
    name: item.navn,
    orgNo: item.organisasjonsnummer,
    orgType: item.orgform.kode
  };
};

var CompanyInput =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CompanyInput, _React$PureComponent);

  function CompanyInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CompanyInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CompanyInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.timeout = null;
    _this.scheduleSearch = _this.scheduleSearch.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    var search = (0, _lodash["default"])(_this.scheduleSearch, 200);
    _this.state = {
      autoComplete: [],
      searchText: "",
      selected: null,
      isLoading: false,
      search: search
    };
    return _this;
  }

  _createClass(CompanyInput, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.selected) {
        this.setState({
          selected: this.props.selected
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }, {
    key: "scheduleSearch",
    value: function scheduleSearch(companyName) {
      var _this2 = this;

      this.setState({
        searchText: companyName
      });

      if (!companyName || companyName.length < 2) {
        this.setState({
          autoComplete: [],
          isLoading: false
        });
        return;
      }

      this.setState({
        isLoading: true
      });
      var filter = "startswith(navn,'".concat(companyName, "')");
      var search = this.props.onSearch ? this.props.onSearch : function () {
        return window.fetch("https://data.brreg.no/enhetsregisteret/enhet.json?page=".concat(0, "&size=", 5, "&$filter=", filter)).then(function (result) {
          return result.json();
        }).then(function (json) {
          return json.data;
        });
      };
      search(companyName).then(function (companies) {
        _this2.setState({
          autoComplete: companies,
          isLoading: false
        });
      })["catch"](function () {
        return _this2.setState({
          autoComplete: [],
          isLoading: false
        });
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      if (this.props.onChange) {
        this.props.onChange(value);
      }

      this.state.search(value);
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(selected) {
      var _this3 = this;

      this.setState({
        selected: selected
      }, function () {
        if (_this3.props.onSelect) {
          _this3.props.onSelect(selected);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          mapItem = _this$props.mapItem,
          inputProps = _this$props.inputProps,
          label = _this$props.label,
          otherProps = _objectWithoutProperties(_this$props, ["onChange", "mapItem", "inputProps", "label"]);

      var _this$state = this.state,
          autoComplete = _this$state.autoComplete,
          isLoading = _this$state.isLoading;

      var renderSelected = function renderSelected(selectedItem, getItemProps, _ref) {
        var clearSelection = _ref.clearSelection;
        var sel = mapItem(selectedItem);
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(SelectLabel, {
          htmlFor: "SelectedName"
        }, label), _react["default"].createElement(ModifiedFlag, {
          reverse: true,
          img: _react["default"].createElement(Close, {
            type: "button",
            onClick: clearSelection
          }, _react["default"].createElement("svg", {
            viewBox: "0 0 26 26",
            width: "26",
            height: "26"
          }, _react["default"].createElement("path", {
            fill: "currentColor",
            d: "M21.7344 19.6406l-2.0977 2.0938c-.3828.3867-1.0078.3867-1.3945 0L13 16.496l-5.2383 5.2383c-.3867.3867-1.0156.3867-1.3984 0l-2.0977-2.0938a.9878.9878 0 0 1 0-1.3984L9.504 13 4.2656 7.7617c-.3828-.3906-.3828-1.0195 0-1.3984l2.0977-2.0977c.3828-.3867 1.0117-.3867 1.3984 0L13 9.5078l5.2422-5.2422c.3867-.3867 1.0156-.3867 1.3945 0l2.0977 2.0938c.3867.3867.3867 1.0156.0039 1.4023L16.496 13l5.2383 5.2422a.9878.9878 0 0 1 0 1.3984z"
          })))
        }, _react["default"].createElement("div", {
          id: "SelectedName"
        }, sel.name), _react["default"].createElement(OrgNo, null, sel.orgNo)));
      };

      var renderInput = function renderInput(getInputProps) {
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Input["default"], _extends({
          label: label
        }, inputProps, getInputProps(_objectSpread2({}, otherProps)))), isLoading && _react["default"].createElement(SelectWrapper, null, _react["default"].createElement(SelectLoad, null)));
      };

      return _react["default"].createElement(_Combobox["default"], {
        onChange: this.handleSelect,
        renderInput: renderInput,
        renderSelected: renderSelected,
        renderLabel: function renderLabel() {
          return null;
        },
        filter: "name",
        indexer: "orgNo",
        options: autoComplete || [],
        downshiftProps: {
          defaultIsOpen: true,
          onInputValueChange: this.handleChange
        }
      }, function (_ref2) {
        var result = _ref2.result,
            getItemProps = _ref2.getItemProps,
            selectedItem = _ref2.selectedItem,
            highlightedIndex = _ref2.highlightedIndex;
        return _react["default"].createElement(SelectWrapper, null, _react["default"].createElement(SelectList, null, result.map(function (item, index) {
          var mappedItem = mapItem(item);
          return _react["default"].createElement(SelectItem, _extends({}, getItemProps({
            item: item
          }), {
            key: mappedItem.orgNo,
            isSelected: highlightedIndex === index
          }), "".concat(mappedItem.name).concat(mappedItem.orgType !== "AS" ? " - " + mappedItem.orgType : ""), _react["default"].createElement(OrgNo, null, mappedItem.orgNo));
        })));
      });
    }
  }]);

  return CompanyInput;
}(_react["default"].PureComponent);

CompanyInput.themeProps = {
  animateLoadFrom: {
    name: "COMPANY_INPUT_LOAD_FROM",
    description: "animation load from",
    type: _themeContants.themePropTypes.style
  },
  animateLoadTo: {
    name: "COMPANY_INPUT_LOAD_FROM",
    description: "animation load from",
    type: _themeContants.themePropTypes.style
  },
  selectLabel: {
    name: "COMPANY_INPUT_LABEL",
    description: "Input label",
    type: _themeContants.themePropTypes.style
  },
  selectLoad: {
    name: "COMPANY_INPUT_SELECT_LOAD",
    description: "Select load",
    type: _themeContants.themePropTypes.style
  },
  selectClose: {
    name: "COMPANY_INPUT_SELECT_CLOSE",
    description: "Select close",
    type: _themeContants.themePropTypes.style
  },
  selectWrapper: {
    name: "COMPANY_INPUT_SELECT_WRAPPER",
    description: "Select wrapper",
    type: _themeContants.themePropTypes.style
  },
  selectList: {
    name: "COMPANY_INPUT_SELECT_LIST",
    description: "Select list",
    type: _themeContants.themePropTypes.style
  },
  selectItem: {
    name: "COMPANY_INPUT_SELECT_ITEM",
    description: "Select item",
    type: _themeContants.themePropTypes.style
  },
  selectFlag: {
    name: "COMPANY_INPUT_FLAG",
    description: "Input flag",
    type: _themeContants.themePropTypes.style
  },
  orgNo: {
    name: "COMPANY_INPUT_ORG_NO",
    description: "Input flag",
    type: _themeContants.themePropTypes.style
  }
};

var Load = function Load() {
  return (0, _styledComponents.keyframes)(["from{background-color:", ";", "}to{background-color:", ";", "}"], _theming.color.bg, (0, _theming.applyVariants)(CompanyInput.themeProps.animateLoadFrom), _theming.color.primary, (0, _theming.applyVariants)(CompanyInput.themeProps.animateLoadTo));
};

var SelectLabel = (0, _styledComponents["default"])(_Label["default"]).withConfig({
  displayName: "CompanyInput__SelectLabel",
  componentId: "sc-5pvu86-0"
})(["", ";"], (0, _theming.applyVariants)(CompanyInput.themeProps.selectLabel));

var SelectLoad = _styledComponents["default"].div.withConfig({
  displayName: "CompanyInput__SelectLoad",
  componentId: "sc-5pvu86-1"
})(["background-color:", ";animation:0.8s ", " ease-in-out infinite alternate;height:", ";width:100%;position:absolute;cursor:pointer;top:0;left:0;z-index:10;box-shadow:0px ", " ", " rgba(0,0,0,0.06);", ";"], _theming.color.white, Load, _theming.spacing.tiny, _theming.spacing.small, _theming.spacing.medium, (0, _theming.applyVariants)(CompanyInput.themeProps.selectLoad));

var Close = _styledComponents["default"].button.withConfig({
  displayName: "CompanyInput__Close",
  componentId: "sc-5pvu86-2"
})(["border-width:0;background-color:transparent;color:", ";cursor:pointer;&:hover,&:focus,&:active{outline:none;color:", ";}svg{width:", ";}", ";"], _theming.color.primary, _theming.color.text, _theming.spacing.medium, (0, _theming.applyVariants)(CompanyInput.themeProps.selectClose));

var ModifiedFlag = (0, _styledComponents["default"])(_Flag["default"]).withConfig({
  displayName: "CompanyInput__ModifiedFlag",
  componentId: "sc-5pvu86-3"
})(["padding:", " ", " ", " ", ";position:relative;", ";"], _theming.spacing.tiny, _theming.spacing.tiny, _theming.spacing.tiny, _theming.spacing.medium, (0, _theming.applyVariants)(CompanyInput.themeProps.selectFlag));

var OrgNo = _styledComponents["default"].div.withConfig({
  displayName: "CompanyInput__OrgNo",
  componentId: "sc-5pvu86-4"
})(["font-size:", ";color:", ";", ";"], _theming.font.tiny, _theming.color.wcag, (0, _theming.applyVariants)(CompanyInput.themeProps.orgNo));

var SelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CompanyInput__SelectWrapper",
  componentId: "sc-5pvu86-5"
})(["position:relative;", ";"], (0, _theming.applyVariants)(CompanyInput.themeProps.selectWrapper));

var SelectList = _styledComponents["default"].ul.withConfig({
  displayName: "CompanyInput__SelectList",
  componentId: "sc-5pvu86-6"
})(["position:absolute;cursor:pointer;top:0;left:0;z-index:10;width:100%;background:", ";box-shadow:0px ", " ", " rgba(0,0,0,0.06);", ";"], _theming.color.white, _theming.spacing.small, _theming.spacing.medium, (0, _theming.applyVariants)(CompanyInput.themeProps.selectList));

var SelectItem = _styledComponents["default"].li.withConfig({
  displayName: "CompanyInput__SelectItem",
  componentId: "sc-5pvu86-7"
})(["list-style:none;padding:", " ", ";background-color:", ";color:", ";border-bottom:1px solid ", ";", "{color:", ";}&:first-child{border-top:1px solid ", ";}", ";"], _theming.spacing.small, _theming.spacing.medium, function (p) {
  return p.isSelected ? _theming.color.primary : "transparent";
}, function (p) {
  return p.isSelected ? _theming.color.white : _theming.color.black;
}, _theming.color.line, OrgNo, function (p) {
  return p.isSelected ? _theming.color.white : _theming.color.wcag;
}, _theming.color.line, (0, _theming.applyVariants)(CompanyInput.themeProps.selectItem));

CompanyInput.propTypes = {
  searchTimeout: _propTypes["default"].number,
  onSelect: _propTypes["default"].func,
  selected: _propTypes["default"].object,
  onSearch: _propTypes["default"].func,
  mapItem: _propTypes["default"].func,
  id: _propTypes["default"].string.isRequired
};
CompanyInput.defaultProps = {
  searchTimeout: 200,
  onSelect: null,
  selected: null,
  mapItem: defaultMapItem
};
var _default = CompanyInput;
exports["default"] = _default;